(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-conservation"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman About Conservation Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutConservation);
    } else {
      initAboutConservation();
    }

    function initAboutConservation() {
      // Find all about-conservation sections
      const sections = document.querySelectorAll('.altman-about-conservation');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get the image
        const image = section.querySelector('.altman-about-conservation__image-wrapper img');

        if (image) {
          // Ensure image loads properly
          image.addEventListener('load', function() {
            // Image loaded successfully
          });

          image.addEventListener('error', function() {
            // Fallback if image fails to load
            const wrapper = section.querySelector('.altman-about-conservation__image-wrapper');
            if (wrapper) {
              wrapper.style.background = 'var(--cream, #FAF8F3)';
            }
          });
        }

        // Get list items
        const listItems = section.querySelectorAll('.altman-about-conservation__list-item');

        listItems.forEach(function(item, index) {
          // Ensure proper role attributes
          item.setAttribute('role', 'listitem');

          // Add keyboard support if needed (for interactive elements)
          // Currently informational only
        });

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-cta"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman About CTA Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutCTA);
    } else {
      initAboutCTA();
    }

    function initAboutCTA() {
      // Find all about-cta sections
      const sections = document.querySelectorAll('.altman-about-cta');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get the button
        const button = section.querySelector('.altman-about-cta__button');

        if (button) {
          // Handle keyboard support (already supported by <a> tags)
          // But we can add additional functionality if needed

          // Handle click for analytics if needed
          button.addEventListener('click', function(e) {
            // Optional: Track CTA click
            // console.log('CTA clicked:', this.textContent);
          });

          // Ensure focus is visible
          button.addEventListener('focus', function(e) {
            // Optional: Add additional focus handling
          });
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman About Hero Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutHero);
    } else {
      initAboutHero();
    }

    function initAboutHero() {
      // Find all about-hero sections
      const sections = document.querySelectorAll('.altman-about-hero');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get the image
        const image = section.querySelector('.altman-about-hero__image');

        if (image) {
          // Ensure image loads properly
          image.addEventListener('load', function() {
            // Image loaded successfully
          });

          image.addEventListener('error', function() {
            // Fallback if image fails to load
            const wrapper = section.querySelector('.altman-about-hero__image-wrapper');
            if (wrapper) {
              wrapper.style.background = 'var(--green-strong, #145C47)';
            }
          });
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-story"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman About Story Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutStory);
    } else {
      initAboutStory();
    }

    function initAboutStory() {
      // Find all about-story sections
      const sections = document.querySelectorAll('.altman-about-story');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get the image
        const image = section.querySelector('.altman-about-story__image-wrapper img');

        if (image) {
          // Ensure image loads properly
          image.addEventListener('load', function() {
            // Image loaded successfully
          });

          image.addEventListener('error', function() {
            // Fallback if image fails to load
            const wrapper = section.querySelector('.altman-about-story__image-wrapper');
            if (wrapper) {
              wrapper.style.background = 'var(--cream, #FAF8F3)';
            }
          });
        }

        // Get the button
        const button = section.querySelector('.altman-about-story__button');

        if (button) {
          // Handle keyboard support (already supported by <a> tags)
          // But we can add additional functionality if needed

          // Handle click for analytics if needed
          button.addEventListener('click', function(e) {
            // Optional: Track analytics
          });
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-video"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman About Video Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAboutVideo);
    } else {
      initAboutVideo();
    }

    function initAboutVideo() {
      // Find all about-video sections
      const sections = document.querySelectorAll('.altman-about-video');

      if (!sections.length) return;

      sections.forEach(function(section) {
        const playBtn = section.querySelector('.altman-about-video__play-btn');
        const closeBtn = section.querySelector('.altman-about-video__close-btn');
        const videoContainer = section.querySelector('.altman-about-video__container');
        const poster = section.querySelector('.altman-about-video__poster');

        if (!playBtn || !videoContainer) return;

        // Store video URL
        const videoUrl = playBtn.getAttribute('data-video-url');
        const videoType = playBtn.getAttribute('data-video-type') || 'youtube';

        if (!videoUrl) {
          // If no video URL, hide play button
          playBtn.style.display = 'none';
          return;
        }

        // Handle play button click
        function openVideo() {
          // Don't open if already open
          if (videoContainer.classList.contains('is-active')) return;

          // Build video embed
          let embedHtml = '';

          if (videoType === 'youtube') {
            const videoId = getYouTubeId(videoUrl);
            if (videoId) {
              embedHtml = `
                <iframe 
                  src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
                  title="Video player"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                  loading="lazy"
                ></iframe>
              `;
            }
          } else if (videoType === 'vimeo') {
            const videoId = getVimeoId(videoUrl);
            if (videoId) {
              embedHtml = `
                <iframe 
                  src="https://player.vimeo.com/video/${videoId}?autoplay=1"
                  title="Video player"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                  loading="lazy"
                ></iframe>
              `;
            }
          } else if (videoType === 'direct') {
            embedHtml = `
              <video 
                controls 
                autoplay
                playsinline
                aria-label="Video player"
              >
                <source src="${videoUrl}" type="video/mp4">
                <p>Your browser does not support video playback.</p>
              </video>
            `;
          }

          if (!embedHtml) {
            // Fallback for unsupported video types
            embedHtml = `
              <div style="display:flex;align-items:center;justify-content:center;height:100%;color:white;padding:20px;text-align:center;">
                <p>Video not available. Please try again later.</p>
              </div>
            `;
          }

          // Insert video
          videoContainer.innerHTML = embedHtml;

          // Add close button back
          if (closeBtn) {
            videoContainer.appendChild(closeBtn);
          } else {
            // If close button doesn't exist, create it
            const newCloseBtn = document.createElement('button');
            newCloseBtn.type = 'button';
            newCloseBtn.className = 'altman-about-video__close-btn';
            newCloseBtn.setAttribute('aria-label', 'Close video');
            newCloseBtn.innerHTML = '<span aria-hidden="true">✕</span>';
            videoContainer.appendChild(newCloseBtn);
            
            // Add event listener
            newCloseBtn.addEventListener('click', closeVideo);
            newCloseBtn.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeVideo();
              }
            });
          }

          // Show video container
          videoContainer.classList.add('is-active');

          // Update ARIA
          playBtn.setAttribute('aria-expanded', 'true');

          // Announce to screen readers
          announceText('Video player opened');

          // Focus management - move focus to video container
          const iframe = videoContainer.querySelector('iframe');
          const video = videoContainer.querySelector('video');
          const focusTarget = iframe || video || videoContainer;
          
          setTimeout(function() {
            if (focusTarget) {
              focusTarget.focus();
            }
          }, 100);

          // Trap focus in modal
          trapFocus(videoContainer);
        }

        // Handle close video
        function closeVideo() {
          // Remove video content
          videoContainer.innerHTML = '';
          
          // Add close button back
          if (closeBtn) {
            videoContainer.appendChild(closeBtn);
          }

          // Hide video container
          videoContainer.classList.remove('is-active');

          // Update ARIA
          playBtn.setAttribute('aria-expanded', 'false');

          // Return focus to play button
          setTimeout(function() {
            playBtn.focus();
          }, 50);

          // Announce to screen readers
          announceText('Video player closed');
        }

        // Event listeners for play button
        playBtn.addEventListener('click', openVideo);
        playBtn.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openVideo();
          }
        });

        // Event listeners for close button
        if (closeBtn) {
          closeBtn.addEventListener('click', closeVideo);
          closeBtn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeVideo();
            }
          });
        }

        // Close video with Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && videoContainer.classList.contains('is-active')) {
            closeVideo();
            e.preventDefault();
          }
        });

        // Helper: Extract YouTube video ID
        function getYouTubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);
          return (match && match[2].length === 11) ? match[2] : null;
        }

        // Helper: Extract Vimeo video ID
        function getVimeoId(url) {
          const regExp = /(?:vimeo\.com\/)(?:[0-9]+)/;
          const match = url.match(regExp);
          return match ? match[0].replace('vimeo.com/', '') : null;
        }

        // Helper: Trap focus in modal
        function trapFocus(container) {
          const focusableElements = container.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          
          if (!focusableElements.length) return;

          const firstFocusable = focusableElements[0];
          const lastFocusable = focusableElements[focusableElements.length - 1];

          container.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                  e.preventDefault();
                  lastFocusable.focus();
                }
              } else {
                if (document.activeElement === lastFocusable) {
                  e.preventDefault();
                  firstFocusable.focus();
                }
              }
            }
          });
        }

        // Helper: Announce text to screen readers
        function announceText(message) {
          // Find or create live region
          let announcer = document.getElementById('altman-accessibility-announcer');
          
          if (!announcer) {
            announcer = document.createElement('div');
            announcer.id = 'altman-accessibility-announcer';
            announcer.setAttribute('aria-live', 'polite');
            announcer.setAttribute('aria-atomic', 'true');
            announcer.className = 'visually-hidden';
            document.body.appendChild(announcer);
          }

          // Update content
          announcer.textContent = '';
          
          // Use setTimeout to ensure the announcement is made
          setTimeout(function() {
            announcer.textContent = message;
          }, 50);
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altman-why-section"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Why Choose Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhyChoose);
    } else {
      initWhyChoose();
    }

    function initWhyChoose() {
      // Find all why-choose sections
      const sections = document.querySelectorAll('.altman-why');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Handle dynamic column adjustments if needed
        const featureItems = section.querySelectorAll('.altman-why__item');
        const list = section.querySelector('.altman-why__list');

        if (!list || !featureItems.length) return;

        // Add keyboard support for interactive elements if any
        // Currently this section is informational, no interactive elements
        // But we can add support for future enhancements

        // Ensure proper role attributes
        featureItems.forEach(function(item, index) {
          item.setAttribute('role', 'listitem');
        });

        // Optional: Add animation on scroll with accessibility consideration
        if ('IntersectionObserver' in window) {
          // Only animate if reduced motion is not preferred
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          
          if (!prefersReducedMotion) {
            const observer = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  // Optional: Add subtle reveal animation
                  // Keep it minimal for accessibility
                }
              });
            }, {
              threshold: 0.1
            });

            observer.observe(section);
          }
        }

        // Listen for accessibility preference changes
        document.addEventListener('accessibilityUpdate', function(e) {
          // Optional: Handle real-time updates if needed
        });
      });

      // Handle image position via CSS
      // This is handled in the schema settings
      // but we can add JS enhancement if needed
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bread-crumb"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Breadcrumb Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBreadcrumb);
    } else {
      initBreadcrumb();
    }

    function initBreadcrumb() {
      // Find all breadcrumb sections
      const sections = document.querySelectorAll('.altman-breadcrumb');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get all breadcrumb links
        const links = section.querySelectorAll('.altman-breadcrumb__link');

        links.forEach(function(link) {
          // Handle keyboard support (already supported by <a> tags)
          // But we can add additional functionality if needed

          // Add focus handling
          link.addEventListener('focus', function(e) {
            // Optional: Add additional focus handling
          });

          // Add click tracking for analytics if needed
          link.addEventListener('click', function(e) {
            // Optional: Track breadcrumb clicks
            // console.log('Breadcrumb clicked:', this.textContent.trim());
          });
        });

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Contact Hero Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactHero);
    } else {
      initContactHero();
    }

    function initContactHero() {
      // Find all contact-hero sections
      const sections = document.querySelectorAll('.altman-contact-hero');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-main"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Contact Main Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactMain);
    } else {
      initContactMain();
    }

    function initContactMain() {
      // Find all contact-main sections
      const sections = document.querySelectorAll('.altman-contact-main');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get form elements
        const form = section.querySelector('.altman-contact-main__form');
        const submitBtn = section.querySelector('.altman-contact-main__submit');
        const statusEl = section.querySelector('.altman-contact-main__status');
        const inputs = section.querySelectorAll('.altman-contact-main__input, .altman-contact-main__select, .altman-contact-main__textarea');

        // Handle form validation
        if (form && submitBtn) {
          form.addEventListener('submit', function(e) {
            // Let Shopify handle the form submission
            // Add loading state
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sending...';

            // Re-enable after submission
            setTimeout(function() {
              submitBtn.disabled = false;
              submitBtn.textContent = '{{ section.settings.submit_label | default: "Send message" }}';
            }, 5000);
          });
        }

        // Handle input validation on blur
        inputs.forEach(function(input) {
          input.addEventListener('blur', function() {
            if (input.hasAttribute('required') && !input.value.trim()) {
              input.classList.add('error');
            } else {
              input.classList.remove('error');
            }
          });

          // Clear error on input
          input.addEventListener('input', function() {
            if (input.classList.contains('error') && input.value.trim()) {
              input.classList.remove('error');
            }
          });

          // Handle email validation
          if (input.type === 'email') {
            input.addEventListener('blur', function() {
              const email = input.value.trim();
              if (email && !isValidEmail(email)) {
                input.classList.add('error');
                showStatus('Please enter a valid email address.', 'error');
              } else if (email) {
                input.classList.remove('error');
                clearStatus();
              }
            });
          }
        });

        // Helper: Validate email
        function isValidEmail(email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(email);
        }

        // Helper: Show status message
        function showStatus(message, type) {
          if (statusEl) {
            statusEl.textContent = message;
            statusEl.className = 'altman-contact-main__status ' + type;
          }
        }

        // Helper: Clear status message
        function clearStatus() {
          if (statusEl) {
            statusEl.textContent = '';
            statusEl.className = 'altman-contact-main__status';
          }
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collections"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Collections Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollections);
    } else {
      initCollections();
    }

    function initCollections() {
      // Find all collections sections
      const sections = document.querySelectorAll('.altman-collections');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Handle keyboard navigation for grid items
        const cards = section.querySelectorAll('.altman-collections__card');

        cards.forEach(function(card, index) {
          // Add keyboard support for Enter/Space (already supported by <a> tags)
          // But we can add additional functionality if needed

          // Ensure focus is visible
          card.addEventListener('focus', function(e) {
            // Optional: Add additional focus handling
          });

          // Handle touch/click events if needed
          card.addEventListener('click', function(e) {
            // Optional: Track analytics or add interaction
          });
        });

        // If there are no cards, we could show a message
        if (cards.length === 0) {
          console.warn('Altman Collections: No collection cards found.');
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Footer Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooter);
    } else {
      initFooter();
    }

    function initFooter() {
      // Find all footer sections
      const sections = document.querySelectorAll('.altman-footer');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get footer elements
        const socialLinks = section.querySelectorAll('.altman-footer__social-link');
        const navLinks = section.querySelectorAll('.altman-footer__col-link');
        const legalLinks = section.querySelectorAll('.altman-footer__legal-link');

        // Handle social links keyboard support
        socialLinks.forEach(function(link) {
          link.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              if (e.key === ' ') {
                e.preventDefault();
                link.click();
              }
            }
          });
        });

        // Add current year to copyright if {{ year }} placeholder exists
        const copyright = section.querySelector('.altman-footer__copyright');
        if (copyright) {
          const text = copyright.textContent;
          const currentYear = new Date().getFullYear();
          if (text.includes('{{ year }}')) {
            copyright.textContent = text.replace('{{ year }}', currentYear);
          }
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }

        // Ensure all links have proper attributes for accessibility
        const allLinks = section.querySelectorAll('a');
        allLinks.forEach(function(link) {
          // If link opens in new tab, add rel and warning for screen readers
          if (link.getAttribute('target') === '_blank') {
            if (!link.getAttribute('rel')) {
              link.setAttribute('rel', 'noopener noreferrer');
            }
          }

          // Ensure empty links are not focusable
          if (!link.getAttribute('href') || link.getAttribute('href') === '#') {
            link.setAttribute('role', 'button');
          }
        });
      });

      // Handle dynamic footer updates (for Shopify sections)
      document.addEventListener('shopify:section:load', function(e) {
        const section = e.target;
        if (section.classList.contains('altman-footer-section')) {
          initFooter();
        }
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Newsletter Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNewsletter);
    } else {
      initNewsletter();
    }

    function initNewsletter() {
      // Find all newsletter sections
      const sections = document.querySelectorAll('.altman-newsletter');

      if (!sections.length) return;

      sections.forEach(function(section) {
        const form = section.querySelector('.altman-newsletter__form');
        const input = section.querySelector('.altman-newsletter__input');
        const message = section.querySelector('.altman-newsletter__message');
        const submitBtn = section.querySelector('.altman-newsletter__submit');

        if (!form || !input || !message) return;

        // Store messages from schema
        const successMessage = '{{ section.settings.success_message | default: "Thank you for subscribing!" }}';
        const errorMessage = '{{ section.settings.error_message | default: "Please enter a valid email address." }}';
        const requiredMessage = '{{ section.settings.error_required | default: "Please enter your email address." }}';

        // Handle form submission
        form.addEventListener('submit', function(e) {
          e.preventDefault();

          // Reset previous messages and states
          clearMessages();
          input.classList.remove('error');

          const email = input.value.trim();

          // Validate email
          if (!email) {
            showMessage(requiredMessage, 'error');
            input.classList.add('error');
            input.focus();
            announceToScreenReader(requiredMessage);
            return;
          }

          if (!isValidEmail(email)) {
            showMessage(errorMessage, 'error');
            input.classList.add('error');
            input.focus();
            announceToScreenReader(errorMessage);
            return;
          }

          // Disable form during submission
          setFormState(true);

          // Simulate submission (replace with actual AJAX)
          simulateSubmission(email, function(success) {
            if (success) {
              showMessage(successMessage, 'success');
              input.value = '';
              announceToScreenReader(successMessage);
              // Optional: Send to Shopify or custom endpoint
              if (form.getAttribute('action')) {
                // If form has action, submit it
                form.submit();
              }
            } else {
              showMessage('Something went wrong. Please try again.', 'error');
              announceToScreenReader('Submission failed. Please try again.');
            }
            setFormState(false);
          });
        });

        // Handle input validation on blur
        input.addEventListener('blur', function() {
          const email = input.value.trim();
          if (email && !isValidEmail(email)) {
            input.classList.add('error');
            showMessage(errorMessage, 'error');
          } else if (email) {
            input.classList.remove('error');
            clearMessages();
          }
        });

        // Clear error on input
        input.addEventListener('input', function() {
          if (input.classList.contains('error')) {
            input.classList.remove('error');
            clearMessages();
          }
        });

        // Keyboard support for enter key
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            form.dispatchEvent(new Event('submit'));
          }
        });

        // Helper: Validate email
        function isValidEmail(email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(email);
        }

        // Helper: Show message
        function showMessage(text, type) {
          message.textContent = text;
          message.className = 'altman-newsletter__message ' + type;
          message.style.opacity = '1';
        }

        // Helper: Clear messages
        function clearMessages() {
          message.textContent = '';
          message.className = 'altman-newsletter__message';
          message.style.opacity = '0';
        }

        // Helper: Set form state
        function setFormState(disabled) {
          input.disabled = disabled;
          submitBtn.disabled = disabled;
          if (disabled) {
            submitBtn.textContent = 'Submitting...';
          } else {
            submitBtn.textContent = '{{ section.settings.submit_label | default: "Subscribe" }}';
          }
        }

        // Helper: Simulate submission (replace with actual API call)
        function simulateSubmission(email, callback) {
          // Simulate network delay
          setTimeout(function() {
            // Always return success for demo
            // Replace with actual AJAX call to Shopify or external service
            callback(true);
          }, 1500);
        }

        // Helper: Announce to screen readers
        function announceToScreenReader(message) {
          // Use the existing message element with aria-live
          // It will automatically announce when content changes
          // We also update the message content for visual users
        }

        // Handle visibility changes for accessibility
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                // Optional: Add animation or tracking
              }
            });
          }, {
            threshold: 0.1
          });

          observer.observe(section);
        }

        // Listen for accessibility preference changes
        document.addEventListener('accessibilityUpdate', function(e) {
          // Optional: Handle real-time updates if needed
        });
      });

      // Global function for form submission success (can be used by Shopify)
      window.altmanNewsletterSuccess = function(sectionId) {
        const section = document.querySelector('.altman-newsletter--' + sectionId);
        if (section) {
          const message = section.querySelector('.altman-newsletter__message');
          if (message) {
            const successMsg = section.querySelector('[data-success-message]');
            if (successMsg) {
              message.textContent = successMsg.textContent;
              message.className = 'altman-newsletter__message success';
            }
          }
        }
      };
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Gallery Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGallery);
    } else {
      initGallery();
    }

    function initGallery() {
      // Find all gallery sections
      const sections = document.querySelectorAll('.altman-gallery');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get all gallery items
        const items = section.querySelectorAll('.altman-gallery__item');

        if (!items.length) {
          console.warn('Altman Gallery: No gallery items found.');
          return;
        }

        // Handle keyboard navigation for items without links
        items.forEach(function(item) {
          const link = item.getAttribute('href');
          
          // If no href, treat as button for keyboard support
          if (!link || link === '#') {
            item.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                // Simulate click
                item.click();
              }
            });

            // Add role="button" if it's a link without href
            if (item.tagName === 'A' && !item.getAttribute('href')) {
              item.setAttribute('role', 'button');
            }
          }

          // Handle click events (for analytics or lightbox)
          item.addEventListener('click', function(e) {
            // Optional: Track gallery click
            
            // If there's no href, prevent default
            if (!link || link === '#') {
              e.preventDefault();
              // Optional: Open lightbox or show larger image
            }
          });

          // Ensure focus is visible
          item.addEventListener('focus', function(e) {
            // Optional: Add additional focus handling
          });
        });

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }

        // Lazy load images with IntersectionObserver for better performance
        if ('IntersectionObserver' in window) {
          const images = section.querySelectorAll('img[loading="lazy"]');
          
          const imageObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                const img = entry.target;
                // Ensure image is loaded
                if (img.complete) {
                  imageObserver.unobserve(img);
                }
              }
            });
          }, {
            rootMargin: '100px'
          });

          images.forEach(function(img) {
            imageObserver.observe(img);
          });
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Hero Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHero);
    } else {
      initHero();
    }

    function initHero() {
      // Find all hero sections on the page
      const heroSections = document.querySelectorAll('.altman-hero');

      if (!heroSections.length) return;

      heroSections.forEach(function(hero) {
        // Add any hero-specific functionality here
        
        // Example: Lazy load images if not already loaded
        const images = hero.querySelectorAll('img[data-src]');
        images.forEach(function(img) {
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  const lazyImg = entry.target;
                  const src = lazyImg.getAttribute('data-src');
                  if (src) {
                    lazyImg.setAttribute('src', src);
                    lazyImg.removeAttribute('data-src');
                  }
                  observer.unobserve(lazyImg);
                }
              });
            });
            observer.observe(img);
          } else {
            // Fallback for older browsers
            const src = img.getAttribute('data-src');
            if (src) {
              img.setAttribute('src', src);
              img.removeAttribute('data-src');
            }
          }
        });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-content"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Policy Content Section JavaScript
  // Handles smooth scrolling, active states, and accessibility
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPolicy);
    } else {
      initPolicy();
    }

    function initPolicy() {
      // Find all policy sections
      const sections = document.querySelectorAll('.altman-policy');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Get TOC links
        const tocLinks = section.querySelectorAll('.altman-policy__toc-link');
        const sectionElements = section.querySelectorAll('.altman-policy__section');

        // Handle smooth scrolling for TOC links
        tocLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = link.getAttribute('href');
            if (targetId) {
              const targetElement = document.querySelector(targetId);
              if (targetElement) {
                const offset = 80; // Offset for fixed header
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                  top: targetPosition,
                  behavior: 'smooth'
                });
                // Update URL hash without causing scroll
                history.pushState(null, null, targetId);
                // Focus the target for accessibility
                targetElement.setAttribute('tabindex', '-1');
                targetElement.focus({ preventScroll: true });
                // Remove tabindex after focus
                setTimeout(function() {
                  targetElement.removeAttribute('tabindex');
                }, 100);
              }
            }
          });

          // Handle keyboard support for Enter/Space
          link.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              link.click();
            }
          });
        });

        // Highlight active TOC link on scroll
        let activeLink = null;

        function updateActiveLink() {
          let currentSection = null;
          const scrollPosition = window.pageYOffset + 120; // Offset for header

          sectionElements.forEach(function(sectionEl) {
            const sectionTop = sectionEl.offsetTop;
            const sectionBottom = sectionTop + sectionEl.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              currentSection = sectionEl;
            }
          });

          // If we're at the bottom of the page, use the last section
          if (!currentSection && (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 10) {
            if (sectionElements.length > 0) {
              currentSection = sectionElements[sectionElements.length - 1];
            }
          }

          // Update active state
          tocLinks.forEach(function(link) {
            const linkSectionId = link.getAttribute('href') ? link.getAttribute('href').replace('#', '') : '';
            const isActive = currentSection && currentSection.id === linkSectionId;

            if (isActive) {
              link.style.color = 'var(--green-strong, #145C47)';
              link.style.borderLeftColor = 'var(--green, #1B785D)';
              if (activeLink !== link) {
                if (activeLink) {
                  activeLink.style.color = '';
                  activeLink.style.borderLeftColor = '';
                }
                activeLink = link;
              }
            } else if (activeLink === link) {
              link.style.color = '';
              link.style.borderLeftColor = '';
              activeLink = null;
            }
          });
        }

        // Throttled scroll handler
        let scrollTimeout;
        window.addEventListener('scroll', function() {
          if (scrollTimeout) {
            window.cancelAnimationFrame(scrollTimeout);
          }
          scrollTimeout = window.requestAnimationFrame(function() {
            updateActiveLink();
          });
        });

        // Initial update
        setTimeout(updateActiveLink, 100);

        // Handle resize
        let resizeTimeout;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            updateActiveLink();
          }, 250);
        });

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Remove smooth scrolling if user prefers reduced motion
          tocLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
              const targetId = link.getAttribute('href');
              if (targetId) {
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                  const offset = 80;
                  window.scrollTo({
                    top: targetElement.getBoundingClientRect().top + window.pageYOffset - offset,
                    behavior: 'auto'
                  });
                }
              }
            });
          });
        }

        // Handle anchor links on page load
        if (window.location.hash) {
          const targetId = window.location.hash;
          setTimeout(function() {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
              const offset = 80;
              window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.pageYOffset - offset,
                behavior: 'smooth'
              });
              targetElement.setAttribute('tabindex', '-1');
              targetElement.focus({ preventScroll: true });
              setTimeout(function() {
                targetElement.removeAttribute('tabindex');
              }, 100);
            }
          }, 300);
        }

        // Handle "Back to Top" button
        const backTop = section.querySelector('.altman-policy__back-top');
        if (backTop) {
          backTop.addEventListener('click', function(e) {
            e.preventDefault();
            const mainElement = document.querySelector('#main');
            if (mainElement) {
              window.scrollTo({
                top: 0,
                behavior: prefersReducedMotion ? 'auto' : 'smooth'
              });
              mainElement.focus({ preventScroll: true });
            }
          });

          backTop.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              backTop.click();
            }
          });
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Sticky Cart Section JavaScript
  // Automatically fetches product info from product page
  // Triggers the main product form submit button
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyCart);
    } else {
      initStickyCart();
    }

    function initStickyCart() {
      // Find all sticky cart sections
      const sections = document.querySelectorAll('.altman-sticky-cart');

      if (!sections.length) return;

      sections.forEach(function(section) {
        const stickyCart = section;
        const addBtn = section.querySelector('.altman-sticky-cart__button');
        const closeBtn = section.querySelector('.altman-sticky-cart__close');
        const mainSubmitBtn = document.querySelector('.product-form__submit, .btn-add-cart, [type="submit"].btn');
        const priceElement = section.querySelector('.altman-sticky-cart__price');
        const variantElement = section.querySelector('.altman-sticky-cart__variant');
        const thumbElement = section.querySelector('.altman-sticky-cart__thumb img');

        // ============================================
        // 1. FETCH PRODUCT INFO FROM PAGE
        // ============================================

        function updateStickyCart() {
          // Get current variant from product form
          const variantInput = document.querySelector('[name="id"]');
          const variantId = variantInput ? variantInput.value : null;

          // Get variant data from Shopify's product JSON
          if (window.product && window.product.variants) {
            const variants = window.product.variants;
            let currentVariant = variants.find(v => v.id == variantId) || variants[0];

            if (currentVariant) {
              // Update price
              if (priceElement) {
                const price = currentVariant.price;
                const formattedPrice = formatMoney(price);
                priceElement.textContent = formattedPrice;
              }

              // Update variant name
              if (variantElement && currentVariant.title && currentVariant.title !== 'Default Title') {
                variantElement.textContent = currentVariant.title;
                variantElement.style.display = 'block';
              } else if (variantElement) {
                variantElement.style.display = 'none';
              }

              // Update thumbnail
              if (thumbElement && currentVariant.featured_image) {
                const imgUrl = currentVariant.featured_image.src;
                thumbElement.src = imgUrl;
                thumbElement.srcset = imgUrl + ' 1x, ' + imgUrl.replace('.jpg', '_200x200.jpg') + ' 2x';
              }

              // Update button state
              if (addBtn) {
                if (currentVariant.available) {
                  addBtn.disabled = false;
                  addBtn.textContent = '{{ section.settings.button_label | default: "Add to cart" }}';
                } else {
                  addBtn.disabled = true;
                  addBtn.textContent = '{{ section.settings.sold_out_label | default: "Sold Out" }}';
                }
              }

              // Update section data attribute
              stickyCart.setAttribute('data-variant-id', currentVariant.id);
            }
          }
        }

        // ============================================
        // 2. FORMAT MONEY HELPER
        // ============================================

        function formatMoney(amount) {
          // Simple money formatter - can be customized
          if (typeof amount === 'number') {
            return '$' + (amount / 100).toFixed(2);
          }
          return '$0.00';
        }

        // ============================================
        // 3. LISTEN FOR VARIANT CHANGES
        // ============================================

        // Listen for variant select changes
        const variantSelectors = document.querySelectorAll('[name="id"], [name="options[Size]"], [name="options[Color]"], .product-form__input select, .product-form__input input[type="radio"]');

        variantSelectors.forEach(function(selector) {
          selector.addEventListener('change', function() {
            setTimeout(updateStickyCart, 100);
          });

          // For radio buttons, also listen for click
          if (selector.type === 'radio') {
            selector.addEventListener('click', function() {
              setTimeout(updateStickyCart, 100);
            });
          }
        });

        // Also listen for Shopify's variant change events
        document.addEventListener('variantChange', function(e) {
          updateStickyCart();
        });

        // ============================================
        // 4. SHOW/HIDE ON SCROLL
        // ============================================

        const productForm = document.querySelector('.product-form, form[action="/cart/add"]');
        
        if (productForm && mainSubmitBtn) {
          const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting) {
                stickyCart.classList.add('is-visible');
                stickyCart.setAttribute('aria-hidden', 'false');
              } else {
                stickyCart.classList.remove('is-visible');
                stickyCart.setAttribute('aria-hidden', 'true');
              }
            });
          }, {
            threshold: 0,
            rootMargin: '0px 0px -100px 0px'
          });

          observer.observe(productForm);
        } else {
          // If no product form found, show sticky cart
          stickyCart.classList.add('is-visible');
          stickyCart.setAttribute('aria-hidden', 'false');
        }

        // ============================================
        // 5. HANDLE ADD TO CART BUTTON
        // ============================================

        if (addBtn && mainSubmitBtn) {
          addBtn.addEventListener('click', function(e) {
            // Trigger click on main product form submit button
            mainSubmitBtn.click();
            
            // Visual feedback
            const originalText = addBtn.textContent;
            addBtn.textContent = 'Adding...';
            addBtn.disabled = true;
            
            // Reset button state after a moment
            setTimeout(function() {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
              // Check if product is still available
              const variantInput = document.querySelector('[name="id"]');
              if (variantInput) {
                const variantId = variantInput.value;
                if (window.product && window.product.variants) {
                  const variant = window.product.variants.find(v => v.id == variantId);
                  if (variant && !variant.available) {
                    addBtn.textContent = '{{ section.settings.sold_out_label | default: "Sold Out" }}';
                    addBtn.disabled = true;
                  }
                }
              }
            }, 3000);
          });

          // Handle keyboard support
          addBtn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              mainSubmitBtn.click();
            }
          });
        }

        // ============================================
        // 6. HANDLE CLOSE BUTTON
        // ============================================

        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            stickyCart.classList.remove('is-visible');
            stickyCart.setAttribute('aria-hidden', 'true');
            localStorage.setItem('stickyCartClosed_' + section.id, 'true');
          });

          closeBtn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeBtn.click();
            }
          });
        }

        // ============================================
        // 7. CHECK CLOSED STATE
        // ============================================

        const isClosed = localStorage.getItem('stickyCartClosed_' + section.id);
        if (isClosed === 'true') {
          stickyCart.classList.remove('is-visible');
          stickyCart.setAttribute('aria-hidden', 'true');
        }

        // ============================================
        // 8. ESCAPE KEY TO CLOSE
        // ============================================

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && stickyCart.classList.contains('is-visible')) {
            if (closeBtn) {
              closeBtn.click();
            }
          }
        });

        // ============================================
        // 9. INITIAL UPDATE
        // ============================================

        // Wait for product data to be available
        setTimeout(updateStickyCart, 500);

        // Also update after page fully loads
        window.addEventListener('load', function() {
          setTimeout(updateStickyCart, 200);
        });

        // ============================================
        // 10. HANDLE AJAX CART UPDATES
        // ============================================

        // Listen for cart updates
        document.addEventListener('cart:updated', function(e) {
          // Update button state if needed
          if (addBtn) {
            addBtn.textContent = '{{ section.settings.button_label | default: "Add to cart" }}';
            addBtn.disabled = false;
          }
        });

        // Listen for section reloads in Shopify
        document.addEventListener('shopify:section:load', function(e) {
          const section = e.target;
          if (section.classList.contains('altman-sticky-cart-section')) {
            initStickyCart();
          }
        });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Story & Video Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStoryVideo);
    } else {
      initStoryVideo();
    }

    function initStoryVideo() {
      // Find all story-video sections
      const sections = document.querySelectorAll('.altman-story');

      if (!sections.length) return;

      sections.forEach(function(section) {
        const playBtn = section.querySelector('.altman-story__play-btn');
        const closeBtn = section.querySelector('.altman-story__close-video');
        const videoContainer = section.querySelector('.altman-story__video-container');
        const thumbnail = section.querySelector('.altman-story__video-thumbnail');

        if (!playBtn || !videoContainer) return;

        // Store video URL
        const videoUrl = playBtn.getAttribute('data-video-url');
        const videoType = playBtn.getAttribute('data-video-type') || 'youtube';

        if (!videoUrl) {
          // If no video URL, hide play button
          playBtn.style.display = 'none';
          return;
        }

        // Handle play button click
        function openVideo() {
          // Don't open if already open
          if (videoContainer.classList.contains('is-active')) return;

          // Build video embed
          let embedHtml = '';

          if (videoType === 'youtube') {
            const videoId = getYouTubeId(videoUrl);
            if (videoId) {
              embedHtml = `
                <iframe 
                  src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
                  title="Video player"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                  loading="lazy"
                ></iframe>
              `;
            }
          } else if (videoType === 'vimeo') {
            const videoId = getVimeoId(videoUrl);
            if (videoId) {
              embedHtml = `
                <iframe 
                  src="https://player.vimeo.com/video/${videoId}?autoplay=1"
                  title="Video player"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                  loading="lazy"
                ></iframe>
              `;
            }
          } else if (videoType === 'direct') {
            embedHtml = `
              <video 
                controls 
                autoplay
                playsinline
                aria-label="Video player"
              >
                <source src="${videoUrl}" type="video/mp4">
                <p>Your browser does not support video playback.</p>
              </video>
            `;
          }

          if (!embedHtml) {
            // Fallback for unsupported video types
            embedHtml = `
              <div style="display:flex;align-items:center;justify-content:center;height:100%;color:white;padding:20px;text-align:center;">
                <p>Video not available. Please try again later.</p>
              </div>
            `;
          }

          // Insert video
          videoContainer.innerHTML = embedHtml;

          // Add close button back
          if (closeBtn) {
            videoContainer.appendChild(closeBtn);
          } else {
            // If close button doesn't exist, create it
            const newCloseBtn = document.createElement('button');
            newCloseBtn.type = 'button';
            newCloseBtn.className = 'altman-story__close-video';
            newCloseBtn.setAttribute('aria-label', 'Close video');
            newCloseBtn.innerHTML = '<span aria-hidden="true">✕</span>';
            videoContainer.appendChild(newCloseBtn);
            
            // Add event listener
            newCloseBtn.addEventListener('click', closeVideo);
            newCloseBtn.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeVideo();
              }
            });
          }

          // Show video container
          videoContainer.classList.add('is-active');

          // Update ARIA
          playBtn.setAttribute('aria-expanded', 'true');

          // Announce to screen readers
          announceText('Video player opened');

          // Focus management - move focus to video container
          const iframe = videoContainer.querySelector('iframe');
          const video = videoContainer.querySelector('video');
          const focusTarget = iframe || video || videoContainer;
          
          setTimeout(function() {
            if (focusTarget) {
              focusTarget.focus();
            }
          }, 100);

          // Trap focus in modal
          trapFocus(videoContainer);
        }

        // Handle close video
        function closeVideo() {
          // Remove video content
          videoContainer.innerHTML = '';
          
          // Add close button back
          if (closeBtn) {
            videoContainer.appendChild(closeBtn);
          }

          // Hide video container
          videoContainer.classList.remove('is-active');

          // Update ARIA
          playBtn.setAttribute('aria-expanded', 'false');

          // Return focus to play button
          setTimeout(function() {
            playBtn.focus();
          }, 50);

          // Announce to screen readers
          announceText('Video player closed');
        }

        // Event listeners for play button
        playBtn.addEventListener('click', openVideo);
        playBtn.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openVideo();
          }
        });

        // Event listeners for close button
        if (closeBtn) {
          closeBtn.addEventListener('click', closeVideo);
          closeBtn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeVideo();
            }
          });
        }

        // Close video with Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && videoContainer.classList.contains('is-active')) {
            closeVideo();
            e.preventDefault();
          }
        });

        // Helper: Extract YouTube video ID
        function getYouTubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);
          return (match && match[2].length === 11) ? match[2] : null;
        }

        // Helper: Extract Vimeo video ID
        function getVimeoId(url) {
          const regExp = /(?:vimeo\.com\/)(?:[0-9]+)/;
          const match = url.match(regExp);
          return match ? match[0].replace('vimeo.com/', '') : null;
        }

        // Helper: Trap focus in modal
        function trapFocus(container) {
          const focusableElements = container.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          
          if (!focusableElements.length) return;

          const firstFocusable = focusableElements[0];
          const lastFocusable = focusableElements[focusableElements.length - 1];

          container.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                  e.preventDefault();
                  lastFocusable.focus();
                }
              } else {
                if (document.activeElement === lastFocusable) {
                  e.preventDefault();
                  firstFocusable.focus();
                }
              }
            }
          });
        }

        // Helper: Announce text to screen readers
        function announceText(message) {
          // Find or create live region
          let announcer = document.getElementById('altman-accessibility-announcer');
          
          if (!announcer) {
            announcer = document.createElement('div');
            announcer.id = 'altman-accessibility-announcer';
            announcer.setAttribute('aria-live', 'polite');
            announcer.setAttribute('aria-atomic', 'true');
            announcer.className = 'visually-hidden';
            document.body.appendChild(announcer);
          }

          // Update content
          announcer.textContent = '';
          
          // Use setTimeout to ensure the announcement is made
          setTimeout(function() {
            announcer.textContent = message;
          }, 50);
        }

        // Handle panel position (CSS handles this via schema)
        const panelPosition = '{{ section.settings.panel_position | default: "left" }}';
        const storyPanel = section.querySelector('.altman-story__panel');
        const videoPanel = section.querySelector('.altman-story__video-panel');

        if (panelPosition === 'right' && storyPanel && videoPanel) {
          // Swap order using CSS grid
          section.style.gridTemplateColumns = '3fr 2fr';
          section.style.direction = 'rtl';
          storyPanel.style.direction = 'ltr';
          videoPanel.style.direction = 'ltr';
        } else {
          section.style.direction = 'ltr';
        }

        // Handle reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          // Additional reduced motion handling if needed
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Video Grid Section JavaScript
  // Simple and clean
  // ============================================

  (function() {
    'use strict';

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoGrid);
    } else {
      initVideoGrid();
    }

    function initVideoGrid() {
      const sections = document.querySelectorAll('.altman-video-grid');

      sections.forEach(function(section) {
        // Get all video cards
        const cards = section.querySelectorAll('.altman-video-grid__card');

        cards.forEach(function(card) {
          // Handle keyboard support
          card.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              // Links already handle Enter, but Space needs handling
              if (e.key === ' ') {
                e.preventDefault();
                card.click();
              }
            }
          });
        });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale"] && !Shopify.designMode) return;
  try {
    
  // ============================================
  // Altman Wholesale Section JavaScript
  // Scoped and self-contained
  // ============================================

  (function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWholesale);
    } else {
      initWholesale();
    }

    function initWholesale() {
      // Find all wholesale sections
      const sections = document.querySelectorAll('.altman-wholesale');

      if (!sections.length) return;

      sections.forEach(function(section) {
        // Handle button position via CSS
        const buttonPosition = '{{ section.settings.button_position | default: "right" }}';
        const alignment = '{{ section.settings.alignment | default: "left" }}';
        
        const inner = section.querySelector('.altman-wholesale__inner');
        const content = section.querySelector('.altman-wholesale__content');
        const button = section.querySelector('.altman-wholesale__button');

        if (!inner || !content) return;

        // Apply text alignment
        if (alignment === 'center') {
          content.style.textAlign = 'center';
          inner.style.justifyContent = 'center';
        } else if (alignment === 'right') {
          content.style.textAlign = 'right';
          inner.style.justifyContent = 'flex-end';
        } else {
          content.style.textAlign = 'left';
        }

        // Handle button position
        if (buttonPosition === 'left' && button) {
          inner.style.flexDirection = 'row-reverse';
        } else if (buttonPosition === 'center' && button) {
          inner.style.justifyContent = 'center';
          button.style.marginLeft = '0';
        } else {
          // Default: button on right
          inner.style.flexDirection = 'row';
        }

        // Ensure button is accessible
        if (button) {
          // Add keyboard support (already supported by <a> tags)
          // But we can add additional functionality if needed
          
          // Ensure focus is visible
          button.addEventListener('focus', function(e) {
            // Optional: Add additional focus handling
          });

          // Handle click for analytics if needed
          button.addEventListener('click', function(e) {
            // Optional: Track analytics
          });
        }

        // Check if button exists
        if (!button) {
          console.warn('Altman Wholesale: No button found.');
        }
      });

      // Listen for accessibility preference changes
      document.addEventListener('accessibilityUpdate', function(e) {
        // Optional: Handle real-time updates if needed
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
